import React from "react";
import { Chatbot } from "./chatbot";
import { toPlainText } from "../../lib/helpers";
import { DEFAULT_COPILOT, DEFAULT_WORKFLOW } from "../../templates/agent";

const DEFAULT_ROLE = "support engineer";

export const AgentSection = ({ section }) => {
  const { agentRef } = section;

  if (!agentRef) {
    return null;
  }

  const {
    role,
    tasks,
    title,
    _rawInterject,
    _rawAnswers,
    steps,
    questions,
    copilot_id,
    workflow_id,
  } = agentRef;

  return (
    <div className="relative">
      <Chatbot
        copilotID={copilot_id || DEFAULT_COPILOT}
        workflowID={workflow_id || DEFAULT_WORKFLOW}
        agentPage={true}
        agent={{
          role: role || DEFAULT_ROLE,
          tasks,
          title,
          interject: toPlainText(_rawInterject),
          answers: toPlainText(_rawAnswers),
          questions: questions,
          steps: steps
            ? steps.map((s) => ({
                goal: s.goal,
                smarts: s.smarts,
                response: toPlainText(s._rawResponse),
                achievement: s.achievement,
              }))
            : [],
        }}
      />
    </div>
  );
};
